import script from "./SupportForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportForm.vue?vue&type=script&setup=true&lang=ts"

import "./SupportForm.vue?vue&type=style&index=0&id=2d40320f&lang=scss"

const __exports__ = script;

export default __exports__